exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".statis[data-v-b02d1662]{padding-bottom:.8em}.text-title[data-v-b02d1662]{font-size:2.5em}.progress[data-v-b02d1662]{margin-top:1em;height:.5em}.candidate-count[data-v-b02d1662],.employer-count[data-v-b02d1662]{font-size:4em;margin-top:.5em;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b02d1662","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserStatistic.vue
// module id = o1Oh
// module chunks = 1